import * as React from 'react';
import styled, { keyframes }  from 'styled-components';
import { useRecoilValue } from 'recoil';//取得のみ
import { nftJsonState } from "../../states/nftJsonState";
import ReactPlayer from "react-player";
import { Box,Center} from '@chakra-ui/react'
import { configJsonState } from '../../states/configJsonState';

type Props = { }
export const NFTRecieveMovie: React.FC<Props> = (props) => {
  const configStatus = useRecoilValue(configJsonState);
  const movieStyle: React.CSSProperties = {
    fontWeight: 'bolder',
    borderRadius: '5px',
    border: '6px solid rgba(255, 255, 255, 0.4)'
  };

  return (
    <div id="nftloadercolumn">
      <Center
        mt={'40px'}
      >
        <ReactPlayer
          url={`${configStatus.nftReceivingMovieUrl}`}
          playing={true}
          playsinline
          volume={0}
          width='80%'
          height='65%'
          muted
          style={movieStyle}
          loop={true}
        />
      </Center>
    </div>
  );
}; 